/**
 * Section: Newsletter Modal
 * ------------------------------------------------------------------------------
 * Newsletter modal configuration for complete theme support
 * - https://github.com/Shopify/theme-scripts/tree/master/packages/theme-sections
 *
 * @namespace newsletterModal
 */

import log from 'salvo-lite/log'

import Cookies from 'js-cookie'
import { register } from '@shopify/theme-sections'

import cssClasses from '../helpers/cssClasses'

class NewsletterModal {
    constructor () {
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit (theme) {
        /**
         * Register the `newsletter-modal` section type.
         * Executes on page load as well as Theme Editor `section:load` events.
         * @param {string} container - selector for the section container DOM element
         */
        register('newsletter-modal', {

            // /**
            //  * Initialise section objects.
            //  */
            init () {
                this._theme = theme
                this._modalCompnent = this._theme.getComponentsById('newsletter-modal')
                this._modal = this._modalCompnent._modal
                this._settings = JSON.parse(this._modalCompnent._elem.getAttribute('data-modal') || '{}')
                this._eventSelectors = {
                    modalClose: `Modal:Close:${this._settings.id}`
                }
            },

            /**
             * Set event listeners on component.
             */
            setEventBusListeners () {
                window.Frame.EventBus.listen('Notification:dismissed', () => this.init())
                window.Frame.EventBus.listen(this._eventSelectors.modalClose, () => this.handleCloseEvents())
            },

            /**
             * Handle close callback function by setting cookie.
             */
            handleCloseEvents () {
                Cookies.set(this._settings.namespace, 'dismissed', {
                    expires: 365
                })
            },

            /**
             * Check if a Cypress test is being run.
             * @returns {Boolean} whether namespace parameter is in URL.
             */
            isTestCondition () {
                if (window.Cypress) {
                    this.handleCloseEvents()
                    return true
                }

                return false
            },

            /**
             * Get all modal elements currently on the DOM.
             * @returns {Array} All currently active modals.
             */
            getAllActiveModals () {
                return Array.from(document.querySelectorAll(`.modal.${cssClasses.active}`))
            },

            /**
             * Callback function when section is loaded in via the 'sections.load()' function or by Theme Editor
             * 'shopify:section:unload' event
             */
            onLoad () {
                this.init()
                this.setEventBusListeners()
                this._modal.init()

                const delay = document.querySelector(`#${this._settings.id}`).getAttribute('data-delay')

                /**
                 * Set conditions on when to show the modal.
                 */
                if (!Cookies.get(this._settings.namespace) && !this.isTestCondition()) {
                    window.setTimeout(() => {
                        if ((this.getAllActiveModals().length !== 0)) {
                            return
                        }

                        if (this.getNotificationPopup()) {
                            return
                        }

                        this._modal.show(this._settings.id)
                    }, delay)
                }
            },

            /**
             * Check if notification container is displayed.
             */
            getNotificationPopup () {
                return document.querySelector(`[js-notification="container"].${cssClasses.active}`)
            },

            /**
             * Callback function when section is unloaded in the by Theme Editor 'shopify:section:unload' event.
             */
            onUnload () {
                this._modal.close(this._settings.id)
            },

            /**
             * Callback function when section is selected in the by Theme Editor 'shopify:section:select' event.
             */
            onSelect () {
                this._modal.show(this._settings.id)
            },

            /**
             * Callback function when section is deselected in the by Theme Editor 'shopify:section:deselect' event.
             */
            onDeselect () {
                this._modal.close()
            }
        })
    }
}

export default NewsletterModal



// WEBPACK FOOTER //
// ./src/resources/scripts/sections/NewsletterModal.js